import { render, staticRenderFns } from "./file-list-with-preview-gallery.vue?vue&type=template&id=b9bc684c"
import script from "./file-list-with-preview-gallery.vue?vue&type=script&lang=js"
export * from "./file-list-with-preview-gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports